module.exports = __webpack_public_path__ + "img/44c504a.webp";